import api from '../../plugins/api';

const removeCar = ({id}) => {
  return api.post('/api/crm/cars/removeCar', {id});
};

export default removeCar;
